module.exports = __webpack_public_path__ + "static/media/soviet_train.b760b006.jpg";